import React, { useRef, useState } from 'react';
import { Images } from '../../assets';

const VideoComponent = ({ src }) => {
    const videoRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(false);

    const togglePlayPause = () => {
        if (videoRef.current) {
            if (isPlaying) {
                videoRef.current.pause();
            } else {
                videoRef.current.play();
            }
            setIsPlaying(!isPlaying);
        }
    };

    return (
        <div style={{ position: "relative", display: "flex", justifyContent: "center", height: "100%" }}>
            <video
                ref={videoRef}
                src={src}
                onPause={() => setIsPlaying(false)}
                onPlay={() => setIsPlaying(true)}
                controls={false}
            />
            <div style={{ position: 'absolute', height: "100%", width: "100%", top: '0', display: "flex", justifyContent: "center", alignItems: "center" }} >
                <button onClick={togglePlayPause}>
                    {isPlaying ?
                        '' :
                        <img src={Images?.videoFormat} />
                    }
                </button>
            </div>
        </div>
    );
};

export default VideoComponent;
